/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, useTheme } from '@coursera/cds-core';

import Markdown from 'bundles/cms/components/Markdown';
import { FootnoteContext, createAnchor } from 'bundles/ent-website/components/FootnoteContext';
import { MAX_PAGE_CONTAINER_WIDTH } from 'bundles/ent-website/constants/layout';

import _t from 'i18n!nls/ent-website';

function FootnoteList() {
  const theme = useTheme();
  const styles = {
    container: css`
      max-width: ${theme.breakpoints.values[MAX_PAGE_CONTAINER_WIDTH]}px;
      padding: 0 ${theme.spacing(64)};
      margin: ${theme.spacing(16)} auto ${theme.spacing(32)};
    `,

    header: css`
      font-size: 12px;
      margin-bottom: ${theme.spacing(8)};
      border-top: 1px solid ${theme.palette.gray[300]};
      padding-top: ${theme.spacing(16)};
    `,

    footnotes: css`
      padding-left: ${theme.spacing(24)};
      color: ${theme.palette.black[500]};

      li {
        line-height: 16px !important;

        div,
        p {
          display: inline;
          font-size: 11px !important;
          line-height: 16px !important;
        }

        a {
          color: ${theme.palette.black[500]};

          &:link,
          &:visited {
            color: ${theme.palette.black[500]};
          }
        }

        &::marker {
          font-size: 11px;
          content: '[' attr(data-num) ']  ';
        }
      }
    `,
  };

  const { getAllFootnotes } = React.useContext(FootnoteContext);

  const footnotes = getAllFootnotes();

  if (footnotes.length <= 0) {
    return null;
  }

  return (
    <Grid container css={styles.container}>
      <Grid item xs={12} css={styles.header}>
        {_t('Source')}
      </Grid>
      <Grid item xs={12}>
        <ol css={styles.footnotes}>
          {footnotes.map((entry) => (
            <li key={entry.key} data-num={entry.num} id={createAnchor(entry.num)}>
              <Markdown source={entry.footnote} />
            </li>
          ))}
        </ol>
      </Grid>
    </Grid>
  );
}

export default FootnoteList;
